module.exports = __webpack_public_path__ + "img/exper-back.5141684e.svg";